import { render, staticRenderFns } from "./r-pagination.vue?vue&type=template&id=89d18f00&"
import script from "./r-pagination.vue?vue&type=script&lang=js&"
export * from "./r-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports